import { render, staticRenderFns } from "./Imoveis.vue?vue&type=template&id=5940e5ad&scoped=true&"
import script from "./imoveis.js?vue&type=script&lang=js&"
export * from "./imoveis.js?vue&type=script&lang=js&"
import style0 from "./Imoveis.vue?vue&type=style&index=0&id=5940e5ad&scoped=true&lang=css&"
import style1 from "./Imoveis.vue?vue&type=style&index=1&id=5940e5ad&lang=scss&rel=stylesheet%2Fscss&scoped=true&"
import style2 from "./Imoveis.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940e5ad",
  null
  
)

export default component.exports